'use strict';

/* Import CSS Plugins and main SCSS */
import 'normalize.css/normalize.css'
import '../css/main.scss';

/* Import custom JS */
import { HANDLES } from './commons/handles';
import { UTILS } from './utils/utils';

window.h5 = {
    init: () => {
        UTILS.init();
        HANDLES.init();
    }
};

window.onload = () => {
    let effectScroll;
    window.h5.init();
};

window.onscroll = () => {
    window.onload.effectScroll = true;
}

setInterval(() => {
    if (window.onload.effectScroll) {
        UTILS.headerAnimate();
        window.onload.effectScroll = false;
    }
}, 200);